import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { params, string, shape, bool } from '@thd-nucleus/data-sources';
import { useProductDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';
import { Overlay } from '@thd-olt-component-react/overlay';
import { DisclaimerMessageContent } from './DisclaimerMessageContent';
import './disclaimer-message.scss';

const DisclaimerMessage = ({ itemId }) => {
  const [open, setOpen] = useState(false);
  const { data, loading, error } = useProductDeprecated({
    itemId,
    domains: ['info']
  });
  // const { data, loading, error } = useDataModel('product', { variables: { itemId } });

  if (!data || loading || (error && !data)) {
    return null;
  }

  const {
    info = {}
  } = data?.product || {};

  if (!info?.forProfessionalUseOnly) {
    return null;
  }
  const openLegalDisclaimer = () => {
    setOpen(true);
  };
  return (
    <div className="disclaimer-message__wrapper disclaimer-message__text disclaimer-message__color">
      <div className="alert-inline alert-inline--warning">
        <span className="alert-inline__message">
          <span className="alert-inline__title">
            <strong>
              This product is for professional and commercial use only. <br />
            </strong>
          </span>
          {'Please review our '}
          <span
            className="u__default-link"
            tabIndex={0}
            role="link"
            onClick={openLegalDisclaimer}
          >
            legal disclaimer
          </span>
          <Overlay
            closeButton
            open={open}
            medium
            onClose={() => setOpen(false)}
            header="Legal Disclaimer"
          >
            <DisclaimerMessageContent />
          </Overlay>
          {' before purchasing this product.'}<br />
        </span>
      </div>
    </div>
  );
};

DisclaimerMessage.displayName = 'DisclaimerMessage';

DisclaimerMessage.dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    info: shape({
      forProfessionalUseOnly: bool()
    })
  })
};

DisclaimerMessage.propTypes = {
  itemId: PropTypes.string
};

DisclaimerMessage.defaultProps = {
  itemId: null
};

export { DisclaimerMessage };
